/**
 * Compare labels in a case-insensitive alphabetical order for search lists.
 */
export const compareSearchListLabels = (aLabel: string, bLabel: string) => {
    const normalisedA = aLabel.toLowerCase();
    const normalisedB = bLabel.toLowerCase();

    if (normalisedA === normalisedB) return 0;
    return normalisedA > normalisedB ? 1 : -1;
};
